export const Destination = {
  Connexion: 0
}